"use client";
import { visuallyHidden } from "./visuallyHidden.css.js";
import { component } from "@gnist/component-utils";
const ScreenReaderOnly = component("ScreenReaderOnly", visuallyHidden, "span");
export {
  ScreenReaderOnly
};
